import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_FunctionsCatalogConfiguratorTab = _resolveComponent("FunctionsCatalogConfiguratorTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_FunctionsCatalogPreviewTable = _resolveComponent("FunctionsCatalogPreviewTable")
  const _component_TabView = _resolveComponent("TabView")
  const _component_FunctionsCatalogPreviewWarningDialog = _resolveComponent("FunctionsCatalogPreviewWarningDialog")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.functionsCatalogPreviewDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.functionsCatalog.previewTitle')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        icon: _ctx.active === 0 ? 'pi pi-chevron-right' : 'pi pi-chevron-left',
        iconPos: _ctx.active === 0 ? 'right' : 'left',
        label: _ctx.active === 0 ? _ctx.$t('common.next') : _ctx.$t('common.back'),
        onClick: _ctx.changeTab
      }, null, 8, ["icon", "iconPos", "label", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_TabView, {
        activeIndex: _ctx.active,
        "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.functionsCatalog.configurator')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_FunctionsCatalogConfiguratorTab, {
                datasets: _ctx.datasets,
                propFunction: _ctx.propFunction,
                onLoading: _ctx.setLoading,
                onSelectedEnvironment: _ctx.setEnvironment,
                onSelectedDataset: _ctx.setDataset
              }, null, 8, ["datasets", "propFunction", "onLoading", "onSelectedEnvironment", "onSelectedDataset"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, { disabled: _ctx.previewInvalid }, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.preview')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_FunctionsCatalogPreviewTable, {
                previewColumns: _ctx.previewColumns,
                previewRows: _ctx.previewRows
              }, null, 8, ["previewColumns", "previewRows"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["activeIndex"]),
      _createVNode(_component_FunctionsCatalogPreviewWarningDialog, {
        visible: _ctx.warningVisible,
        warningTitle: _ctx.warningTitle,
        warningMessage: _ctx.warningMessage,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.warningVisible = false))
      }, null, 8, ["visible", "warningTitle", "warningMessage"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}